<template>
  <div class="container h-100 d-flex flex-column px-0">
    <slot />
  </div>
</template>
